import { createContext } from 'react';

export const DeleteUserModalContext = createContext({
  open: (userId: string) => {},
});
